import { useBrandLoaderData } from "../../../root/rootLoader.ts";

export function useHelp() {
  const brand = useBrandLoaderData();

  const isVirtualStore = !!brand.VirtualStore.companyId;

  const hasWhatsNew = brand.Onboarding.enabled && !isVirtualStore;

  const hasMissingBooks = brand.Support.MissingBooks.enabled && !isVirtualStore;

  const hasGeneralSupport = brand.Support.enabled;
  // We wouldn't show topics if general support links were off
  const hasTopicBreakdown =
    (hasGeneralSupport && brand.Support.Topics.enabled) || isVirtualStore;

  // If VirtualStore is enabled, we use it's support URL
  const supportURL = isVirtualStore
    ? brand.VirtualStore.Support.url
    : brand.Support.url;

  const accessCodesURL = isVirtualStore
    ? "https://onlinebookstoresupport.vitalsource.com/hc/en-us/articles/32728795965719-Your-Online-Bookstore-Digital-Content#h_01JXE2GQ2FCQJHTGRNVRZF3AT4"
    : "https://bookshelfsupport.vitalsource.com/hc/en-us/articles/32271411552023-How-do-I-redeem-my-Publisher-Access-Code";

  return {
    hasGeneralSupport,
    generalSupportURL: brand.Support.url,
    hasWhatsNew,
    hasMissingBooks,
    missingBooksURL: brand.Support.MissingBooks.url,
    hasTopicBreakdown,
    isVirtualStore,
    supportURL,
    accessCodesURL,
  };
}
